import { Button, Checkbox, Modal } from "antd";

export default function DeleteEpisode({ props }) {
  return (
    <Modal
      visible={props.deleteVisible}
      title="Delete this episode?"
      onCancel={props.toggleDeletePopup}
      footer={[
        <Button key="Back" onClick={props.toggleDeletePopup}>
          Return
        </Button>,
        <Button
          type="danger"
          key="Delete"
          className={"btn btn-success"}
          loading={props.loading}
          onClick={props.hardDelete}
        >
          Permanent Delete
        </Button>,
      ]}
    >
      <div className="p-2">{props.episodeData?.episode_name}</div>

      <div className="p-2-small-text">
        <ul>
          <li>
            <p>
              episode number {props.episodeData?.episode_number} from course: <strong>{props.episodeData?.course?.course_name}</strong>
            </p>
          </li>
        </ul>
      </div>

      <div className="p-2">
        <strong>Check all</strong> the items below to confirm episode
        deletion, Deleting a episode is permanent and <strong>cannot</strong> be undone
      </div>

      <div className="frame-detail">
        <div>
          <Checkbox
            onChange={(value) => {
              props.setCheckBox1(value.target.checked);
            }}
            checked={props.checkBox1}
          >
            Any future access of the data will be impossible
          </Checkbox>
        </div>

        <div>
          <Checkbox
            onChange={(value) => {
              props.setCheckBox2(value.target.checked);
            }}
            checked={props.checkBox2}
          >
            Any record relate to this episode (user episode progress) will be permanently delete
          </Checkbox>
        </div>
      </div>
    </Modal>
  );
}
